export enum EventPhotoType {
  DDT = 'ddt',
  MERCE_DANNEGGIATA = 'merce_danneggiata',
}
